import React, { useState } from 'react';
import { LoggedInNav } from '../components/LoggedInNav';
import { MailIcon, CalendarIcon, DatabaseIcon, SlackIcon, VideoIcon, FileTextIcon, UserIcon, BellIcon, GlobeIcon, CreditCardIcon, CheckIcon, XIcon, PlusIcon, TrashIcon, UserPlusIcon, ShieldIcon } from 'lucide-react';
export function Settings() {
  const [activeTab, setActiveTab] = useState('integrations');
  const [users, setUsers] = useState([{
    id: 1,
    name: 'John Smith',
    email: 'john.smith@example.com',
    role: 'Admin'
  }, {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sarah.j@example.com',
    role: 'General'
  }, {
    id: 3,
    name: 'Michael Wong',
    email: 'michael.w@example.com',
    role: 'General'
  }]);
  const [whitelistedDomains, setWhitelistedDomains] = useState([{
    id: 1,
    domain: 'competitor.com'
  }, {
    id: 2,
    domain: 'internal-docs.techcorp.com'
  }, {
    id: 3,
    domain: 'private-data.org'
  }]);
  const [newDomain, setNewDomain] = useState('');
  const addDomain = () => {
    if (newDomain.trim()) {
      setWhitelistedDomains([...whitelistedDomains, {
        id: whitelistedDomains.length + 1,
        domain: newDomain.trim()
      }]);
      setNewDomain('');
    }
  };
  const removeDomain = id => {
    setWhitelistedDomains(whitelistedDomains.filter(domain => domain.id !== id));
  };
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-3185">
      <LoggedInNav data-id="element-3186" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3187">
        <div className="mb-8" data-id="element-3188">
          <h1 className="text-2xl font-bold" data-id="element-3189">Command HQ</h1>
          <p className="text-[#F5F7FA] text-opacity-70" data-id="element-3190">
            Manage your integrations and preferences
          </p>
        </div>
        <div className="flex flex-col md:flex-row gap-8" data-id="element-3191">
          <div className="md:w-64 flex-shrink-0" data-id="element-3192">
            <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-4" data-id="element-3193">
              <button onClick={() => setActiveTab('integrations')} className={`w-full text-left px-4 py-3 rounded-lg flex items-center space-x-3 ${activeTab === 'integrations' ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'text-[#F5F7FA] hover:bg-[#F5F7FA] hover:bg-opacity-10'}`} data-id="element-3194">
                <DatabaseIcon className="h-5 w-5" data-id="element-3195" />
                <span data-id="element-3196">Integrations</span>
              </button>
              <button onClick={() => setActiveTab('settings')} className={`w-full text-left px-4 py-3 rounded-lg flex items-center space-x-3 ${activeTab === 'settings' ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'text-[#F5F7FA] hover:bg-[#F5F7FA] hover:bg-opacity-10'}`} data-id="element-3197">
                <UserIcon className="h-5 w-5" data-id="element-3198" />
                <span data-id="element-3199">Settings</span>
              </button>
            </div>
          </div>
          <div className="flex-1" data-id="element-3200">
            {activeTab === 'integrations' && <div className="space-y-8" data-id="element-3201">
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3202">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3203">Email</h2>
                  <div className="space-y-4" data-id="element-3204">
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3205">
                      <div className="flex items-center space-x-4" data-id="element-3206">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3207">
                          <MailIcon className="h-5 w-5 text-[#C8F169]" data-id="element-3208" />
                        </div>
                        <div data-id="element-3209">
                          <h3 className="font-medium" data-id="element-3210">Gmail</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3211">
                            Connect your Gmail account
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full" data-id="element-3212">
                        <CheckIcon className="h-4 w-4" data-id="element-3213" />
                        <span className="text-sm" data-id="element-3214">Connected</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3215">
                      <div className="flex items-center space-x-4" data-id="element-3216">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3217">
                          <MailIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3218" />
                        </div>
                        <div data-id="element-3219">
                          <h3 className="font-medium" data-id="element-3220">Outlook</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3221">
                            Connect your Outlook account
                          </p>
                        </div>
                      </div>
                      <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-3 py-1 rounded-full text-sm flex items-center space-x-1" data-id="element-3222">
                        <PlusIcon className="h-4 w-4" data-id="element-3223" />
                        <span data-id="element-3224">Connect</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3225">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3226">Calendar</h2>
                  <div className="space-y-4" data-id="element-3227">
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3228">
                      <div className="flex items-center space-x-4" data-id="element-3229">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3230">
                          <CalendarIcon className="h-5 w-5 text-[#C8F169]" data-id="element-3231" />
                        </div>
                        <div data-id="element-3232">
                          <h3 className="font-medium" data-id="element-3233">Google Calendar</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3234">
                            Connect your Google Calendar
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full" data-id="element-3235">
                        <CheckIcon className="h-4 w-4" data-id="element-3236" />
                        <span className="text-sm" data-id="element-3237">Connected</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3238">
                      <div className="flex items-center space-x-4" data-id="element-3239">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3240">
                          <CalendarIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3241" />
                        </div>
                        <div data-id="element-3242">
                          <h3 className="font-medium" data-id="element-3243">Microsoft Calendar</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3244">
                            Connect your Microsoft Calendar
                          </p>
                        </div>
                      </div>
                      <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-3 py-1 rounded-full text-sm flex items-center space-x-1" data-id="element-3245">
                        <PlusIcon className="h-4 w-4" data-id="element-3246" />
                        <span data-id="element-3247">Connect</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3248">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3249">CRM</h2>
                  <div className="space-y-4" data-id="element-3250">
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3251">
                      <div className="flex items-center space-x-4" data-id="element-3252">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3253">
                          <DatabaseIcon className="h-5 w-5 text-[#C8F169]" data-id="element-3254" />
                        </div>
                        <div data-id="element-3255">
                          <h3 className="font-medium" data-id="element-3256">HubSpot</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3257">
                            Connect your HubSpot account
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full" data-id="element-3258">
                        <CheckIcon className="h-4 w-4" data-id="element-3259" />
                        <span className="text-sm" data-id="element-3260">Connected</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3261">
                      <div className="flex items-center space-x-4" data-id="element-3262">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3263">
                          <DatabaseIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3264" />
                        </div>
                        <div data-id="element-3265">
                          <h3 className="font-medium" data-id="element-3266">Salesforce</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3267">
                            Connect your Salesforce account
                          </p>
                        </div>
                      </div>
                      <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-3 py-1 rounded-full text-sm flex items-center space-x-1" data-id="element-3268">
                        <PlusIcon className="h-4 w-4" data-id="element-3269" />
                        <span data-id="element-3270">Connect</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3271">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3272">
                    Other Integrations
                  </h2>
                  <div className="space-y-4" data-id="element-3273">
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3274">
                      <div className="flex items-center space-x-4" data-id="element-3275">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3276">
                          <SlackIcon className="h-5 w-5 text-[#C8F169]" data-id="element-3277" />
                        </div>
                        <div data-id="element-3278">
                          <h3 className="font-medium" data-id="element-3279">Slack</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3280">
                            Connect your Slack workspace
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full" data-id="element-3281">
                        <CheckIcon className="h-4 w-4" data-id="element-3282" />
                        <span className="text-sm" data-id="element-3283">Connected</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3284">
                      <div className="flex items-center space-x-4" data-id="element-3285">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3286">
                          <FileTextIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3287" />
                        </div>
                        <div data-id="element-3288">
                          <h3 className="font-medium" data-id="element-3289">Notion</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3290">
                            Connect your Notion workspace
                          </p>
                        </div>
                      </div>
                      <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-3 py-1 rounded-full text-sm flex items-center space-x-1" data-id="element-3291">
                        <PlusIcon className="h-4 w-4" data-id="element-3292" />
                        <span data-id="element-3293">Connect</span>
                      </button>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3294">
                      <div className="flex items-center space-x-4" data-id="element-3295">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3296">
                          <VideoIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3297" />
                        </div>
                        <div data-id="element-3298">
                          <h3 className="font-medium" data-id="element-3299">Zoom</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3300">
                            Connect your Zoom account
                          </p>
                        </div>
                      </div>
                      <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-3 py-1 rounded-full text-sm flex items-center space-x-1" data-id="element-3301">
                        <PlusIcon className="h-4 w-4" data-id="element-3302" />
                        <span data-id="element-3303">Connect</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
            {activeTab === 'settings' && <div className="space-y-8" data-id="element-3304">
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3305">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3306">
                    Profile & Preferences
                  </h2>
                  <div className="flex items-start space-x-6 mb-6" data-id="element-3307">
                    <div className="w-20 h-20 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold" data-id="element-3308">
                      JS
                    </div>
                    <div className="flex-1" data-id="element-3309">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3310">
                        <div data-id="element-3311">
                          <label className="block text-sm text-[#F5F7FA] text-opacity-70 mb-1" data-id="element-3312">
                            First Name
                          </label>
                          <input type="text" defaultValue="John" className="w-full bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3313" />
                        </div>
                        <div data-id="element-3314">
                          <label className="block text-sm text-[#F5F7FA] text-opacity-70 mb-1" data-id="element-3315">
                            Last Name
                          </label>
                          <input type="text" defaultValue="Smith" className="w-full bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3316" />
                        </div>
                        <div data-id="element-3317">
                          <label className="block text-sm text-[#F5F7FA] text-opacity-70 mb-1" data-id="element-3318">
                            Email
                          </label>
                          <input type="email" defaultValue="john.smith@example.com" className="w-full bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3319" />
                        </div>
                        <div data-id="element-3320">
                          <label className="block text-sm text-[#F5F7FA] text-opacity-70 mb-1" data-id="element-3321">
                            Company
                          </label>
                          <input type="text" defaultValue="TechCorp" className="w-full bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3322" />
                        </div>
                      </div>
                      <div className="mt-4" data-id="element-3323">
                        <button className="bg-[#C8F169] text-[#1E2A38] px-4 py-2 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-3324">
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="border-t border-[#F5F7FA] border-opacity-10 pt-6 mb-6" data-id="element-3325">
                    <h3 className="font-medium mb-4" data-id="element-3326">Data Privacy</h3>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3327">
                      <div className="flex-1 pr-4" data-id="element-3328">
                        <h3 className="font-medium mb-1" data-id="element-3329">
                          Email Scanning Consent
                        </h3>
                        <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3330">
                          Allow Prepz.io to access and scan my inbox
                          continuously to deliver meeting summaries and
                          insights. Data is handled securely. Consent can be
                          withdrawn anytime.
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer flex-shrink-0" data-id="element-3331">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-3332" />
                        <div className="w-11 h-6 bg-[#F5F7FA] bg-opacity-20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-[#F5F7FA] after:border-[#F5F7FA] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#C8F169]" data-id="element-3333"></div>
                      </label>
                    </div>
                  </div>
                  <div className="border-t border-[#F5F7FA] border-opacity-10 pt-6" data-id="element-3334">
                    <h3 className="font-medium mb-4" data-id="element-3335">Appearance</h3>
                    <div className="flex items-center space-x-4" data-id="element-3336">
                      <button className="bg-[#1A2331] border-2 border-[#C8F169] px-4 py-2 rounded-lg text-sm font-medium" data-id="element-3337">
                        Dark Mode
                      </button>
                      <button className="bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 px-4 py-2 rounded-lg text-sm font-medium" data-id="element-3338">
                        Light Mode
                      </button>
                      <button className="bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 px-4 py-2 rounded-lg text-sm font-medium" data-id="element-3339">
                        System Default
                      </button>
                    </div>
                  </div>
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3340">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3341">Manage Users</h2>
                  <div className="mb-6" data-id="element-3342">
                    <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-3343">
                      Add additional users to your account and manage their
                      permissions.
                    </p>
                    <div className="overflow-hidden rounded-lg border border-[#F5F7FA] border-opacity-10 mb-4" data-id="element-3344">
                      <table className="min-w-full divide-y divide-[#F5F7FA] divide-opacity-10" data-id="element-3345">
                        <thead className="bg-[#1A2331]" data-id="element-3346">
                          <tr data-id="element-3347">
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#F5F7FA] text-opacity-70 uppercase tracking-wider" data-id="element-3348">
                              Name
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#F5F7FA] text-opacity-70 uppercase tracking-wider" data-id="element-3349">
                              Email
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#F5F7FA] text-opacity-70 uppercase tracking-wider" data-id="element-3350">
                              Profile
                            </th>
                            <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-[#F5F7FA] text-opacity-70 uppercase tracking-wider" data-id="element-3351">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-[#1A2331] divide-y divide-[#F5F7FA] divide-opacity-10" data-id="element-3352">
                          {users.map(user => <tr key={user.id} data-id="element-3353">
                              <td className="px-6 py-4 whitespace-nowrap" data-id="element-3354">
                                <div className="flex items-center" data-id="element-3355">
                                  <div className="h-8 w-8 rounded-full bg-[#F5F7FA] bg-opacity-10 flex items-center justify-center text-sm font-medium" data-id="element-3356">
                                    {user.name.split(' ').map(n => n[0]).join('')}
                                  </div>
                                  <div className="ml-3" data-id="element-3357">
                                    <div className="text-sm font-medium" data-id="element-3358">
                                      {user.name}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap" data-id="element-3359">
                                <div className="text-sm" data-id="element-3360">{user.email}</div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap" data-id="element-3361">
                                <div className="flex items-center" data-id="element-3362">
                                  {user.role === 'Admin' ? <div className="flex items-center" data-id="element-3363">
                                      <ShieldIcon className="h-4 w-4 text-[#C8F169] mr-1" data-id="element-3364" />
                                      <span className="text-sm" data-id="element-3365">
                                        {user.role}
                                      </span>
                                    </div> : <div className="flex items-center" data-id="element-3366">
                                      <UserIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-70 mr-1" data-id="element-3367" />
                                      <span className="text-sm" data-id="element-3368">
                                        {user.role}
                                      </span>
                                    </div>}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-3369">
                                {user.role !== 'Admin' && <button className="text-[#F5F7FA] text-opacity-70 hover:text-opacity-100 ml-2" data-id="element-3370">
                                    <TrashIcon className="h-4 w-4" data-id="element-3371" />
                                  </button>}
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                    <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-4 py-2 rounded-lg text-sm flex items-center" data-id="element-3372">
                      <UserPlusIcon className="h-4 w-4 mr-2" data-id="element-3373" />
                      Add User
                    </button>
                  </div>
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3374">
                  <h2 className="text-xl font-medium mb-4" data-id="element-3375">
                    Whitelist Domains
                  </h2>
                  <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-3376">
                    Insert domains that you don't want to research or process
                    via Prepz.io
                  </p>
                  <div className="flex items-center space-x-2 mb-6" data-id="element-3377">
                    <input type="text" value={newDomain} onChange={e => setNewDomain(e.target.value)} placeholder="example.com" className="flex-1 bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3378" />
                    <button onClick={addDomain} className="bg-[#C8F169] text-[#1E2A38] px-4 py-2 rounded-lg font-medium hover:bg-opacity-90 transition-all flex items-center" data-id="element-3379">
                      <PlusIcon className="h-4 w-4 mr-1" data-id="element-3380" />
                      Add
                    </button>
                  </div>
                  {whitelistedDomains.length > 0 ? <div className="overflow-hidden rounded-lg border border-[#F5F7FA] border-opacity-10" data-id="element-3381">
                      <table className="min-w-full divide-y divide-[#F5F7FA] divide-opacity-10" data-id="element-3382">
                        <thead className="bg-[#1A2331]" data-id="element-3383">
                          <tr data-id="element-3384">
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#F5F7FA] text-opacity-70 uppercase tracking-wider" data-id="element-3385">
                              Domain
                            </th>
                            <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-[#F5F7FA] text-opacity-70 uppercase tracking-wider" data-id="element-3386">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-[#1A2331] divide-y divide-[#F5F7FA] divide-opacity-10" data-id="element-3387">
                          {whitelistedDomains.map(domain => <tr key={domain.id} data-id="element-3388">
                              <td className="px-6 py-4 whitespace-nowrap" data-id="element-3389">
                                <div className="flex items-center" data-id="element-3390">
                                  <div className="h-4 w-4 text-[#F5F7FA] text-opacity-70 mr-2" data-id="element-3391" />
                                  <div className="text-sm" data-id="element-3392">{domain.domain}</div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-3393">
                                <button onClick={() => removeDomain(domain.id)} className="text-[#F5F7FA] text-opacity-70 hover:text-opacity-100" data-id="element-3394">
                                  <TrashIcon className="h-4 w-4" data-id="element-3395" />
                                </button>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div> : <div className="bg-[#1A2331] rounded-lg p-6 text-center" data-id="element-3396">
                      <div className="h-8 w-8 text-[#F5F7FA] text-opacity-40 mx-auto mb-2" data-id="element-3397" />
                      <p className="text-[#F5F7FA] text-opacity-70" data-id="element-3398">
                        No domains have been whitelisted yet
                      </p>
                    </div>}
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3399">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3400">
                    Timezone & Calendar Sync
                  </h2>
                  <div className="space-y-6" data-id="element-3401">
                    <div data-id="element-3402">
                      <label className="block text-sm text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-3403">
                        Timezone
                      </label>
                      <select className="w-full bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3404">
                        <option data-id="element-3405">Pacific Time (UTC-8)</option>
                        <option data-id="element-3406">Mountain Time (UTC-7)</option>
                        <option data-id="element-3407">Central Time (UTC-6)</option>
                        <option data-id="element-3408">Eastern Time (UTC-5)</option>
                        <option data-id="element-3409">GMT (UTC+0)</option>
                        <option data-id="element-3410">Central European Time (UTC+1)</option>
                      </select>
                    </div>
                    <div data-id="element-3411">
                      <h3 className="font-medium mb-3" data-id="element-3412">
                        Calendar Sync Settings
                      </h3>
                      <div className="space-y-3" data-id="element-3413">
                        <div className="flex items-center justify-between" data-id="element-3414">
                          <label className="text-sm" data-id="element-3415">
                            Sync events from the past
                          </label>
                          <select className="bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-3 py-1 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3416">
                            <option data-id="element-3417">1 month</option>
                            <option data-id="element-3418">3 months</option>
                            <option data-id="element-3419">6 months</option>
                            <option data-id="element-3420">1 year</option>
                          </select>
                        </div>
                        <div className="flex items-center justify-between" data-id="element-3421">
                          <label className="text-sm" data-id="element-3422">
                            Sync events to the future
                          </label>
                          <select className="bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-3 py-1 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3423">
                            <option data-id="element-3424">1 month</option>
                            <option data-id="element-3425">3 months</option>
                            <option data-id="element-3426">6 months</option>
                            <option data-id="element-3427">1 year</option>
                          </select>
                        </div>
                        <div className="flex items-center justify-between" data-id="element-3428">
                          <label className="text-sm" data-id="element-3429">Frequency of Check</label>
                          <select className="bg-[#1A2331] border border-[#F5F7FA] border-opacity-10 rounded-lg px-3 py-1 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-3430">
                            <option data-id="element-3431">Hourly</option>
                            <option data-id="element-3432">Daily</option>
                            <option data-id="element-3433">Weekly</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-[#1A2331] rounded-lg" data-id="element-3434">
                      <div className="flex items-center space-x-4" data-id="element-3435">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3436">
                          <GlobeIcon className="h-5 w-5 text-[#C8F169]" data-id="element-3437" />
                        </div>
                        <div data-id="element-3438">
                          <h3 className="font-medium" data-id="element-3439">Auto-detect Timezone</h3>
                          <p className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3440">
                            Automatically update timezone based on location
                          </p>
                        </div>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-3441">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-3442" />
                        <div className="w-11 h-6 bg-[#F5F7FA] bg-opacity-20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-[#F5F7FA] after:border-[#F5F7FA] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#C8F169]" data-id="element-3443"></div>
                      </label>
                    </div>
                    <button className="bg-[#C8F169] text-[#1E2A38] px-4 py-2 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-3444">
                      Save Changes
                    </button>
                  </div>
                </div>
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-6" data-id="element-3445">
                  <h2 className="text-xl font-medium mb-6" data-id="element-3446">
                    Subscription & Billing
                  </h2>
                  <div className="bg-[#1A2331] rounded-lg p-4 mb-6" data-id="element-3447">
                    <div className="flex items-center justify-between mb-4" data-id="element-3448">
                      <div data-id="element-3449">
                        <h3 className="font-medium" data-id="element-3450">Current Plan</h3>
                        <div className="flex items-center mt-1" data-id="element-3451">
                          <span className="text-xl font-bold text-[#C8F169] mr-2" data-id="element-3452">
                            Pro
                          </span>
                          <span className="bg-[#C8F169] bg-opacity-20 px-2 py-0.5 rounded-full text-xs text-[#C8F169]" data-id="element-3453">
                            Annual
                          </span>
                        </div>
                      </div>
                      <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-3 py-1 rounded-lg text-sm" data-id="element-3454">
                        Change Plan
                      </button>
                    </div>
                    <div className="border-t border-[#F5F7FA] border-opacity-10 pt-4" data-id="element-3455">
                      <div className="flex justify-between mb-2" data-id="element-3456">
                        <span className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3457">
                          Next billing date
                        </span>
                        <span className="text-sm" data-id="element-3458">June 15, 2023</span>
                      </div>
                      <div className="flex justify-between" data-id="element-3459">
                        <span className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3460">
                          Amount
                        </span>
                        <span className="text-sm" data-id="element-3461">$199/year</span>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3462">
                    <h3 className="font-medium mb-4" data-id="element-3463">Payment Method</h3>
                    <div className="bg-[#1A2331] rounded-lg p-4 flex items-center justify-between mb-4" data-id="element-3464">
                      <div className="flex items-center space-x-4" data-id="element-3465">
                        <div className="w-10 h-10 bg-[#F5F7FA] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-3466">
                          <CreditCardIcon className="h-5 w-5 text-[#C8F169]" data-id="element-3467" />
                        </div>
                        <div data-id="element-3468">
                          <div className="font-medium" data-id="element-3469">Visa ending in 4242</div>
                          <div className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3470">
                            Expires 12/24
                          </div>
                        </div>
                      </div>
                      <button className="text-[#F5F7FA] text-opacity-70 hover:text-opacity-100 text-sm" data-id="element-3471">
                        Edit
                      </button>
                    </div>
                    <button className="text-[#C8F169] text-sm flex items-center hover:underline" data-id="element-3472">
                      <PlusIcon className="h-4 w-4 mr-1" data-id="element-3473" />
                      Add Payment Method
                    </button>
                  </div>
                  <div className="mt-6 border-t border-[#F5F7FA] border-opacity-10 pt-6" data-id="element-3474">
                    <h3 className="font-medium mb-4" data-id="element-3475">Billing History</h3>
                    <div className="space-y-3" data-id="element-3476">
                      <div className="bg-[#1A2331] rounded-lg p-3 flex items-center justify-between" data-id="element-3477">
                        <div data-id="element-3478">
                          <div className="text-sm font-medium" data-id="element-3479">
                            Pro Plan - Annual
                          </div>
                          <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-3480">
                            June 15, 2022
                          </div>
                        </div>
                        <div className="text-right" data-id="element-3481">
                          <div className="text-sm" data-id="element-3482">$199.00</div>
                          <div className="text-xs text-[#C8F169]" data-id="element-3483">Paid</div>
                        </div>
                      </div>
                      <div className="bg-[#1A2331] rounded-lg p-3 flex items-center justify-between" data-id="element-3484">
                        <div data-id="element-3485">
                          <div className="text-sm font-medium" data-id="element-3486">
                            Pro Plan - Annual
                          </div>
                          <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-3487">
                            June 15, 2021
                          </div>
                        </div>
                        <div className="text-right" data-id="element-3488">
                          <div className="text-sm" data-id="element-3489">$199.00</div>
                          <div className="text-xs text-[#C8F169]" data-id="element-3490">Paid</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}